import * as actionTypes from "../constants/actionTypes";

export function toggleMenu(isActive) {
	return {type: actionTypes.TOGGLE_MAIN_MENU, isActive};
}

export function toggleAdminMenuOpen(isAdminMenuOpen) {
	return {type: actionTypes.TOGGLE_ADMIN_MENU, isAdminMenuOpen};
}